// eslint-disable-next-line no-underscore-dangle
const isImgNode = node => node.type.__isImgNode === true;

export default isImgNode;